<template>
  <div class="md-layout">
    <div class="md-layout-item" :style="{ paddingLeft: isMobile.isMobile ? '0px' : '15px' }">
      <v-dialog
        v-model="showQrCodeStatus"
        scrollable
        :overlay="false"
        max-width="200px"
        transition="dialog-transition"
      >
        <v-card>
          <img :src="url" alt="" style="width: 200px; height: 200px" />
        </v-card>
      </v-dialog>
      <div :style="{ overflow: 'hidden', margin: isMobile.isMobile ? '10px 15px' : '0' }">
        <md-toolbar
          elevation="3"
          class="mobileShow"
          :style="{
            height: isMobile.isMobile ? '44px' : '64px',
            minHeight: isMobile.isMobile ? '44px' : '64px',
          }"
        >
          <span
            :style="{
              width: '80px',
              float: 'left',
              color: '#fff',
              margin: isMobile.isMobile ? '0px 0px 0px 0px' : '20px',
              height: isMobile.isMobile ? '25px' : '',
              lineHeight: isMobile.isMobile ? '25px' : '',
            }"
            >特效资源库</span
          >
          <v-btn
            large
            class="md-button md-success dropdown-toggle addModel"
            @click="handleResourceNew"
            :style="{
              margin: isMobile.isMobile ? '0px !important' : '0px',
              height: isMobile.isMobile ? '25px' : '',
              lineHeight: isMobile.isMobile ? '25px' : '',
            }"
          >
          <span class="iconfont icon-tianjia" style="font-size: 17px; margin-right: 2px"></span
          >添加特效
          </v-btn>
          <!-- 
          <v-menu transition="slide-y-transition" offset-y nudge-bottom="5" :close-on-click="true">
            <template v-slot:activator="{ on, attrs, value }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="md-button md-success dropdown-toggle deviceFilter"
              >
                {{ typeMap[type] }}
                <v-icon :class="['ni', value ? 'rotate-180' : '']"
                  >ni ni-bold-down text-xs ms-1</v-icon
                >
              </v-btn>
            </template>

            <v-list class="py-1" dense max-height="300">
              <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                <v-list-item
                  class="list-item-hover-active py-0 text-center"
                  v-for="(item, index) in typeList"
                  :key="index"
                  @click="chooseType(item)"
                >
                  <v-list-item-content class="pa-0">
                    <v-list-item-title
                      v-text="item.name"
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                    >
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu> -->

          <md-button
            v-if="isMobile.isMobile"
            class="md-toolbar-toggle md-just-icon md-round md-simple md-toolbar-section-end"
            :class="{ toggled: $sidebar.showSidebar }"
            :style="{ float: 'right', color: '#fff !important', height: '25px' }"
            @click.stop="toggleSidebar"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>

          <!-- <v-menu
         
              v-for="(list, index) in queryParams"
              :key="index"
              transition="slide-y-transition"
              offset-y
              nudge-bottom="5"
              :close-on-click="true"
              :disabled="list.disabled"
            >
              <template v-slot:activator="{ on, attrs, value }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="md-button md-success dropdown-toggle specialityFilter"
                  :class="list.disabled ? 'disable-color' : ''"
                >
                  {{ categoryName }}
                  <v-icon :class="['ni', value ? 'rotate-180' : '']"
                    >ni ni-bold-down text-xs ms-1</v-icon
                  >
                </v-btn>
              </template>

              <v-list class="py-1" dense max-height="300">
                <v-list-item-group
                  v-model="list.value"
                  active-class="v-List-actived"
                  mandatory
                  color="indigo"
                  @change="changeQueryParams(list, $event)"
                >
                  <v-list-item
                    class="list-item-hover-active py-0 text-center"
                    v-for="(item, index) in list.listData"
                    :key="index"
                  >
                    <v-list-item-content class="pa-0">
                      <v-list-item-title
                        v-text="item.name"
                        class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                      >
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
       -->
        </md-toolbar>
      </div>
      <v-card
        class="md-layout md-alignment-center"
        :style="{
          marginLeft: isMobile.isMobile ? '15px' : '0px',
          marginRight: isMobile.isMobile ? '15px' : '0px',
          width: isMobile.isMobile ? 'auto' : '100%',
        }"
      >
        <!-- 搜索栏  -->
        <v-toolbar color="success" class="pcShow">
          <span style="width: 80px; float: left; color: #fff; margin: 20px">特效资源库</span>

          <v-btn large class="md-button md-success dropdown-toggle" @click="handleResourceNew">
            <span class="iconfont icon-tianjia" style="font-size: 17px; margin-right: 2px"></span
          >添加特效
            <!-- 新建模型资源 -->
            <!-- <md-tooltip md-direction="top">添加特效</md-tooltip> -->
          </v-btn>

          <v-spacer></v-spacer>
          <div class="d-sm-flex justify-between">
            <div class="d-flex ms-auto">
              <v-menu
                transition="slide-y-transition"
                offset-y
                nudge-bottom="5"
                :close-on-click="true"
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="md-button md-success dropdown-toggle deviceFilter"
                  >
                    {{ typeMap[type] }}
                    <v-icon :class="['ni', value ? 'rotate-180' : '']"
                      >ni ni-bold-down text-xs ms-1</v-icon
                    >
                  </v-btn>
                </template>

                <v-list class="py-1" dense max-height="300">
                  <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                    <v-list-item
                      class="list-item-hover-active py-0 text-center"
                      v-for="(item, index) in typeList"
                      :key="index"
                      @click="chooseType(item)"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title
                          v-text="item.name"
                          class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                        >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
              <v-menu
                v-for="(list, index) in queryParams"
                :key="index"
                transition="slide-y-transition"
                offset-y
                nudge-bottom="5"
                :close-on-click="true"
                :disabled="list.disabled"
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="md-button md-success dropdown-toggle specialityFilter"
                    :class="list.disabled ? 'disable-color' : ''"
                  >
                    {{ categoryName }}
                    <v-icon :class="['ni', value ? 'rotate-180' : '']"
                      >ni ni-bold-down text-xs ms-1</v-icon
                    >
                  </v-btn>
                </template>

                <v-list class="py-1" dense max-height="300">
                  <v-list-item-group
                    v-model="list.value"
                    active-class="v-List-actived"
                    mandatory
                    color="indigo"
                    @change="changeQueryParams(list, $event)"
                  >
                    <v-list-item
                      class="list-item-hover-active py-0 text-center"
                      v-for="(item, index) in list.listData"
                      :key="index"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title
                          v-text="item.name"
                          class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                        >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </div>
          </div>
        </v-toolbar>

        <!-- 此处是为了兼容移动端故而备份了这个几个下拉列表 -->

        <!-- 此处是为了兼容移动端故而备份了这个几个下拉列表 -->

        <v-card-text style="padding-top: 7px">
          <v-toolbar flat height="80" class="toolbarWrap">
            <v-text-field
              v-model="searchQuery"
              class="filterValue"
              append-icon="mdi-magnify"
              label="请输入名称"
              single-line
              hide-details
              @keydown="keydownSearch"
            ></v-text-field>

            <md-tooltip md-direction="top">按回车以检索</md-tooltip>
          </v-toolbar>
          <v-row dense class="modelListWrap">
            <v-progress-linear
              v-show="loading"
              :active="loading"
              :indeterminate="loading"
            ></v-progress-linear>
            <v-col
              v-if="courseListLoading"
              v-for="(item, index) in 8"
              :key="index"
              class="guJiaWrap md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100"
            >
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`">
                <v-skeleton-loader class="mx-auto" max-width="100%" type="card"></v-skeleton-loader>
              </v-sheet>
            </v-col>
            <div
              v-if="modelResourceList.length > 0"
              v-for="modelResource in modelResourceList"
              :key="modelResource.id"
              :class="
                isMobile.isMobile
                  ? 'modelList'
                  : 'modelList md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100'
              "
            >
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-expand-transition>
                    <v-card
                      :style="{
                        marginLeft: isMobile.isMobile ? '0px !important' : '8px',
                        marginRight: isMobile.isMobile ? '0px important' : '8px',
                      }"
                      hover
                      :class="[`elevation-${hover ? 20 : 2}`, 'transition-swing']"
                      @click="handleResourceDetail(modelResource)"
                    >
                      <div class="cardWrap">
                        <v-img
                          :src="modelResource.effects_review_img"
                          :lazy-src="modelResource.effects_review_img"
                          class="white--text align-end"
                          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                          :height="isMobile.isMobile ? '75px' : '200px'"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <div class="maskingWrap">
                          <p style="color: #fff; padding: 5px">
                            {{ modelResource.effects_description }}
                          </p>
                          <!-- <v-chip
                              v-for="(tag, index) in modelResource.tagList"
                              :key="index"
                              label
                              color="green"
                              dark
                              small
                              class="mr-1"
                              >{{ tag }}</v-chip
                            > -->
                          <v-spacer></v-spacer>

                          <div class="iconWrap">
                            <v-icon small @click.stop="showQrCode" style="float: left; color: #fff">
                              mdi-qrcode
                            </v-icon>
                            <v-btn color="success" style="float: right" text small>免费</v-btn>
                          </div>
                        </div>
                      </div>

                      <v-card-actions :style="{ padding: isMobile.isMobile ? '0px' : '8px' }">
                        <p style="margin: 0px; text-align: center; width: 100%; font-size: 12px">
                          {{ modelResource.effects_name }}
                        </p>
                      </v-card-actions>
                    </v-card>
                  </v-expand-transition>
                </template>
              </v-hover>
            </div>
          </v-row>
        </v-card-text>

        <!-- 分页 -->
        <Pagination
          :page.sync="pagination.page"
          :total="pagination.total"
          :itemsSelect="[4, 8, 20, 40]"
          :items-per-page.sync="pagination.itemsPerPage"
          @refresh="getEffectsResource"
        />

        <resourceLibDetail
          :showDetailDialog="showDetailDialog"
          :selectedResource="selectedResource"
          @handleDetailCancel="handleDetailCancel"
          @handleDetailSubmit="handleDetailSubmit"
          v-if="showDetailDialog"
        />

        <ResourceLibNew
          :showNewDialog="showNewDialog"
          @handleCloseDialog="handleCloseDialog"
          v-if="showNewDialog"
        />
      </v-card>
    </div>
  </div>
</template>
<script>
import ResourceLibNew from './Action/ResourceLibNew';
import resourceLibDetail from './Action/resourceLibDetail';
import Pagination from '@/components/Pagination/index';
import { getEffectsResource } from '@/api/model_resource';
import QRcode from 'qrcode';
import { _Base64encode } from '@/util/base64';
import { mapGetters } from 'vuex';
export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  name: 'Resource',
  components: {
    resourceLibDetail,
    ResourceLibNew,
    // ModelPreview,
    Pagination,
  },
  data() {
    return {
      courseListLoading: false,
      // 选中的模型id
      model_id: '',
      // 模型展示弹框控制
      previewModelStatus: false,
      // 搜索条件
      searchQuery: '',
      // 加载
      loading: true,
      // 查询参数
      queryParams: [
        {
          level: 'Level_1',
          value: 0,
          code: '',
          title: '专业分类',
          listData: [],
          disabled: false,
        },
      ],
      categoryName: '专业分类',
      typeList: [
        {
          name: '设备',
          type: 'device',
        },
        {
          name: '角色',
          type: 'role',
        },
        {
          name: '工具',
          type: 'tool',
        },
        {
          name: '场景',
          type: 'scene',
        },
      ],
      typeMap: {},
      type: 'device',
      // 分页
      pagination: {
        page: 1,
        itemsPerPage: 8,
        total: 0,
      },
      showDetailDialog: false,
      showNewDialog: false,
      checkList: [],
      selectedItem: {},
      modelResourceList: [],
      selectedResource: {},

      showTagList: false,
      showQrCodeStatus: false,
      url: '',
    };
  },
  watch: {},
  destroyed() {
    this.$EventBus.$off('viewModel');
  },
  mounted() {
    this.courseListLoading = true;
  },

  created() {
    this.typeMap = this.typeList.reduce((pre, next) => {
      pre[next.type] = next.name;
      return pre;
    }, {});
    this.getEffectsResource();
    this.initDict('device');
    // this.getTagList();
    let that = this;
    this.$EventBus.$on('viewModel', function (data) {
      if (data) {
        that.showDetailDialog = true;
      } else {
        that.showDetailDialog = false;
      }
    });
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    handleDetailCancel() {
      this.showDetailDialog = false;
      this.pagination.page = 1;
      this.getEffectsResource();
    },
    handleDetailSubmit() {
      // this.refreshResourceList();
      this.showDetailDialog = false;
    },
    async showQrCode(item) {
      const _this = this;
      QRcode.toDataURL(
        'http://file-preview.icubespace.com/onlinePreview?url=' +
          encodeURIComponent(_Base64encode(item.model_file))
      ).then(url => {
        _this.url = url;
        _this.showQrCodeStatus = true;
      });
    },

    /**
     * 模型展示
     */
    handleResourcePreview(model) {
      if (!model.model_amrt_file_list_json) {
        this.$store.dispatch('global/showWarningMsg', '模型尚未转换无法预览');
        return;
      }
      this.model_id = model._id;
      this.previewModelStatus = true;
    },

    /**
     * 初始化字典
     * 请求专业分类接口
     */
    initDict(cate_type) {
      let arr = {
        code: '-1',
        name: '全部',
      };
      this.$dic.getCategoryList(
        {
          cate_type: cate_type,
          level: '1',
        },
        res => {
          if (res.length > 0) {
            res.unshift(arr);
          }
          this.queryParams[0].listData = res;
          this.queryParams[0].code = '';
        }
      );
    },
    /**
     * 选择框选择刷新
     */
    changeQueryParams(rows, index) {
      const map = {
        Level_1: () => {
          this.queryParams[0].code = rows.listData[index].code;
          this.categoryName = rows.listData[index].name;
          this.pagination.page = 1;
          this.getEffectsResource();
        },
        Level_2: () => {
          console.log('Level_2');
        },
        Level_3: () => {
          console.log('Level_3');
        },
      };
      map[rows.level]();
    },
    /**
     * 搜索框点击enter事件
     */
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.getEffectsResource();
      }
    },
    /**
     * 查看详情
     */
    handleResourceDetail(item) {
      this.showDetailDialog = true;
      this.selectedResource = item;
    },

    getEffectsResource() {
      let tempData1 = {
        effects_name: this.searchQuery || '',
        page_no: this.pagination.page || '',
        page_size: this.pagination.itemsPerPage,
      };
      this.showTagList = false;
      this.loading = true;
      getEffectsResource(tempData1)
        .then(res => {
          this.courseListLoading = false;
          this.loading = false;
          this.modelResourceList = res.data.items;
          this.pagination.total = res.data.total;
        })
        .catch(() => {
          this.courseListLoading = false;
        });
    },

    handleResourceNew() {
      this.showNewDialog = true;
    },

    handleCloseDialog(res) {
      this.showNewDialog = false;
      if (res) {
        this.getEffectsResource();
        console.log(res);
      }
    },
    chooseType({ type }) {
      this.type = type;
      this.initDict(type);
      this.getEffectsResource();
    },
  },
};
</script>
<style scoped>
.img-card {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.img {
  width: 200px;
  height: 180px;
  margin: 0 !important;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0;
}

.md-tab {
  max-width: 600px;
  max-height: 400px;
  overflow: auto;
}

.v-List-actived {
  background: #ddd;
}

.v-application .indigo--text {
  background: #fff;
}

.disable-color {
  color: #ddd !important;

  i {
    color: #ddd !important;
  }
}

.mobileShow {
  display: none;
}

@media (max-width: 1160px) {
  .modelList  {
    height: 160px !important;
    margin: 10px 0;
  }

  .vcardWrap {
    height: 160px !important;
  }

  .cardWrap {
    height: 130px !important;
  }

  .v-image{
    height: 130px !important;
  }
  .maskingWrap {
    height: 130px !important;
  }
  .model_name {
    height: 30px !important;
    line-height: 30px !important;
  }
  .model_name p {
    height: 30px !important;
    line-height: 30px !important;
    margin-bottom: 0px;
    margin-top: 0px;
  }
}

@media (max-width: 850px) {
  .modelList  {
    height: 130px !important;
    margin: 10px 0;
  }

  .vcardWrap {
    height: 130px !important;
  }

  .cardWrap {
    height: 100px !important;
  }

  .v-image{
    height: 130px !important;
  }
  .maskingWrap {
    height: 100px !important;
  }
  .model_name {
    height: 30px !important;
    line-height: 30px !important;
  }
  .model_name p {
    height: 30px !important;
    line-height: 30px !important;
    margin-bottom: 0px;
    margin-top: 0px;
  }
}

@media (max-width: 750px) {
  .modelList  {
    height: 100px !important;
    margin: 10px 0;
  }

  .vcardWrap {
    height: 100px !important;
  }

  .cardWrap {
    height: 80px !important;
  }

  .v-image{
    height: 80px !important;
  }
  .maskingWrap {
    height: 80px !important;
  }
  .model_name {
    height: 20px !important;
    line-height: 20px !important;
  }
  .model_name p {
    height: 20px !important;
    line-height: 20px !important;
    margin-bottom: 0px;
    margin-top: 0px;
    font-size: 12px;
  }
}
@media (max-width: 599px) {
  .pcShow {
    display: none;
  }
  .mobileShow {
    display: block;
    background: #4caf50 !important;
    overflow: hidden;
    /* display: flex;
  justify-content: space-around;
  align-items: center; */
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
      0 1px 10px 0 rgba(0, 0, 0, 0.12);
  }
  .filterValue {
    padding-left: 0px;
    padding-right: 0px;
  }

  >>> .toolbarWrap .v-toolbar__content {
    padding: 4px 0px !important;
  }

  .modelListWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 490px;
    align-content: flex-start;
  }
  .modelList {
    width: 48% !important;
    height: 105px;
  }
}
.cardWrap {
  position: relative;
  overflow: hidden;
  border-radius: 5px 5px 0 0; 
}

.maskingWrap {
  position: absolute;
  left: 9;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  background-color: #000000a3;
  transition: 0.5s;
  opacity: 0;
}

.cardWrap:hover .maskingWrap {
  opacity: 1;
}
.iconWrap {
  overflow: hidden;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  justify-content: flex-end;
}
.md-layout-item {
  padding-right: 0px;
}
</style>
